import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "progress-container"
}
const _hoisted_2 = { class: "progress-header" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "progress-counter" }
const _hoisted_5 = { class: "progress-bar-container" }

import { useProgressStore } from '@/stores/progressStore';

// Use the store instead of props

export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  setup(__props) {

const progressStore = useProgressStore();

return (_ctx: any,_cache: any) => {
  return (_unref(progressStore).visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(progressStore).title), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(progressStore).current) + " / " + _toDisplayString(_unref(progressStore).total) + " " + _toDisplayString(_unref(progressStore).totalsLabel), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "progress-bar",
            style: _normalizeStyle({ width: _unref(progressStore).progressPercentage + '%' })
          }, null, 4)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})